var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 57,
    viewBox: "0 0 72 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6977 43.5045C12.1322 43.0656 12.7295 42.8096 13.3631 42.8096H70.8197C71.8696 42.8096 72.3946 44.0896 71.6524 44.8394L60.3023 56.3052C59.8678 56.7441 59.2705 57.0001 58.6369 57.0001H1.1803C0.130365 57.0001 -0.394601 55.7201 0.347592 54.9703L11.6977 43.5045Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6977 0.694899C12.1503 0.256015 12.7476 0 13.3631 0H70.8197C71.8696 0 72.3946 1.28008 71.6524 2.02984L60.3023 13.4957C59.8678 13.9346 59.2705 14.1906 58.6369 14.1906H1.1803C0.130365 14.1906 -0.394601 12.9105 0.347592 12.1607L11.6977 0.694899Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3023 21.9627C59.8678 21.5238 59.2705 21.2678 58.6369 21.2678H1.1803C0.130365 21.2678 -0.394601 22.5479 0.347592 23.2977L11.6977 34.7635C12.1322 35.2024 12.7295 35.4584 13.3631 35.4584H70.8197C71.8696 35.4584 72.3946 34.1783 71.6524 33.4286L60.3023 21.9627Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/Solana.643920e4deb5369b2b2fd66ab1d569a7.svg";
export { ForwardRef as ReactComponent };